import { render, staticRenderFns } from "./DeclarationValidity.vue?vue&type=template&id=61b20f82&"
import script from "./DeclarationValidity.vue?vue&type=script&lang=js&"
export * from "./DeclarationValidity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports